"use client";

import React from "react";
import { MapPin, Calendar, Briefcase } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "@/components/ui/pagination";
const projects = [{
  id: 1,
  title: "High-Rise Foundation Analysis",
  location: "Downtown Metro, NY",
  scope: "Deep Foundation Testing",
  year: "2023",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550713/img/high_rise_foundation_site.png",
  height: "h-96"
}, {
  id: 2,
  title: "Coastal Erosion Study",
  location: "Pacific Coast Hwy, CA",
  scope: "Slope Stability Analysis",
  year: "2022",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550713/img/coastal_erosion_cliff.png",
  height: "h-64"
}, {
  id: 3,
  title: "Industrial Warehouse Soil Prep",
  location: "Logistics Park, TX",
  scope: "Soil Compaction Testing",
  year: "2023",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550713/img/industrial_warehouse_ground.png",
  height: "h-80"
}, {
  id: 4,
  title: "Bridge Piling Inspection",
  location: "River Crossing, OH",
  scope: "Structural Integrity Check",
  year: "2021",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550713/img/bridge_piling_construction.png",
  height: "h-72"
}, {
  id: 5,
  title: "Highway Expansion Geotech",
  location: "Interstate 95, FL",
  scope: "Subgrade Evaluation",
  year: "2024",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550713/img/highway_expansion_roadwork.png",
  height: "h-80"
}, {
  id: 6,
  title: "Residential Development Survey",
  location: "Suburban Heights, WA",
  scope: "Site Investigation",
  year: "2022",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550713/img/residential_development_land.png",
  height: "h-64"
}];
export default function ProjectExperience() {
  return;
}